import { UILibrary } from '@/consts/ui-library';

export const DEFAULT_UI_LIBRARY = UILibrary.tdesign;

// 针对没有配置过ui库的场景，我们需要使用下面这个变量
// 因为像是tdesign是需要插件启动才能使用的
export const FALLBACK_UI_LIBRARY =  UILibrary.antd;

export const DEFAULT_ICON = 'https://vfiles.gtimg.cn/vupload/20210813/7e35b01628823110001.png';

// 是否在物料面板展示组件所属的「组件商店」信息，由 server 启动项 xySetting.showComponentStoreInfo 下发
export const showComponentStoreInfo = window.DESIGN_SETTINGS?.showComponentStoreInfo ?? false;
